// StockAnciennete.jsx
import React from "react";
import "./stockAnciennete.scss";
import { Card, Tag, Space, Empty } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';

const StockAnciennete = ({ stock }) => {
  const data = Array.isArray(stock) && stock.length > 0 ? stock : [];

  const getTagColor = (status) => {
    if (status === 'Normal') return 'green';
    if (status === 'Promo') return 'orange';
    return 'default';
  };

  if (data.length === 0) {
    return (
      <Card 
        className="stockAnciennete"
        bordered={false}
        title={
          <Space>
            <CalendarOutlined style={{ fontSize: 18, color: '#1a1a1a' }} />
            <span style={{ fontSize: 15, fontWeight: 600 }}>Stock par ancienneté</span>
          </Space>
        }
        extra={
          <Tag color="default">Taux vendu</Tag>
        }
      >
        <Empty 
          description="Aucune donnée disponible"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          style={{ padding: '20px 0' }}
        />
      </Card>
    );
  }

  return (
    <Card 
      className="stockAnciennete"
      bordered={false}
      title={
        <Space>
          <CalendarOutlined style={{ fontSize: 18, color: '#1a1a1a' }} />
          <span style={{ fontSize: 15, fontWeight: 600 }}>Stock par ancienneté</span>
        </Space>
      }
      extra={
        <Tag color="default">Taux vendu</Tag>
      }
    >
      <div className="stockAnciennete_body">
        {data.map((item, index) => (
          <div key={index} className="stockAnciennete_row">
            <div className="stockAnciennete_left">
              <span className={`stockAnciennete_dot stockAnciennete_dot--${item.color}`}></span>
              <span className="stockAnciennete_period">{item.period}</span>
            </div>
            <div className="stockAnciennete_right">
              <span className="stockAnciennete_count">{item.count}</span>
              <Tag color={getTagColor(item.status)} className="stockAnciennete_tag">
                {item.status}
              </Tag>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default StockAnciennete;